<template>
  <div id="contenedor-tool-bar-pagos">
    <v-toolbar
      flat
      dense>
      <div
        style="width: 150px" class="mr-2">
        <ejercicio-picker
          v-model="filtros.ejercicio"
          class="mr-2">
        </ejercicio-picker>
      </div>
      <custom-auto-complete
        v-model="filtros.idContratista"
        cols="3"
        label="Contratista"
        :items="proveedores"
        item-text="nombreRazonSocial"
        item-value="id">
      </custom-auto-complete>
      <div
        style="width: 350px"
        class="mr-2">
        <custom-text-field
          label="Buscar..."
          append-icon="mdi-magnify"
          clearable
          @keyup="buscar"
          @click:clear="limpiarBuscadorTexto">
        </custom-text-field>
      </div>
      <v-spacer></v-spacer>
      <custom-button
        @click="nuevo"
        label="Nuevo"
        tipo="agregar">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import CustomAutoComplete from '@/components/inputs/Autocomplete.vue';

export default {
  name: 'ToolBarPagos',
  components: {
    EjercicioPicker,
    CustomButton,
    CustomTextField,
    CustomAutoComplete,
  },
  props: {
    proveedores: Array,
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
    nuevo() {
      this.$emit('nuevoPago');
    },
  },
};
</script>

<style lang="scss">

</style>
